module.exports = __webpack_public_path__ + "4da203e2ffe11fc0b05a2907c70cc684.png";